<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">

					<div class="loginCard vx-row no-gutter justify-center items-center">

						<div class="vx-col hidden lg:block lg:w-1/2">
							<img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
						</div>

						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="p-8 login-tabs-container">

								<div class="vx-card__title mb-4">
									<h4 class="mb-4">Login bij Piqwise</h4>
									<p>Welkom terug, log hier met je piqwise account</p>
								</div>

								<div>
									<form data-vv-scope="loginForm" @submit.prevent="submit">
										<vs-input
											name="email"
											icon-no-border
											icon="icon icon-user"
											icon-pack="feather"
											label="Email"
											v-model="form.email"
											class="w-full"
											v-validate="'required|email'" />
										<span class="text-danger text-sm" v-show="errors.has('loginForm.email')">{{
												errors.first('loginForm.email')
											}}</span>


										<vs-input
											type="password"
											name="password"
											icon-no-border
											icon="icon icon-lock"
											icon-pack="feather"
											label="Wachtwoord"
											v-model="form.password"
											class="w-full mt-6"
											v-validate="'required'" />
										<span class="text-danger text-sm" v-show="errors.has('loginForm.password')">{{
												errors.first('loginForm.password')
											}}</span>

										<div
											class="flex flex-wrap justify-between my-5">
											<vs-checkbox v-model="form.checkbox_remember_me" class="mb-3">Onthoud mij
											</vs-checkbox>
											<router-link to="forgetpassword">Wachtwoord vergeten?</router-link>
										</div>
										<router-link to="register">
											<vs-button type="border">Registreren</vs-button>
										</router-link>
										<vs-button button="submit" type="relief" class="float-right">Login</vs-button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import {mapActions} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);

const dict = {
	custom: {
		email: {
			required: 'Dit veld is verplicht',
			email: 'Vul een geldig e-mailadres in',
		},
		password: {
			required: 'Dit veld is verplicht',
		}
	}
};

Validator.localize('en', dict);

export default {
	data() {
		return {
			form: {
				email: '',
				password: '',
				checkbox_remember_me: false
			},
			apiurl: process.env.APP_API_URL
		};
	},
	methods: {
		...mapActions({
			signIn: 'auth/signIn'
		}),

		submit() {
			this.$vs.loading({
				container: '.loginCard',
				scale: 0.6
			});
			this.$validator.validate().then(result => {
				if (result) {
					this.signIn(this.form).then(() => {

						this.$router.replace({
							name: 'dashboard'
						}).catch(() => {
							this.$vs.loading.close('.loginCard > .con-vs-loading');
						});

						this.$vs.loading.close('.loginCard > .con-vs-loading');
						this.$vs.notify({
							title: 'Gelukt!',
							text: 'Het inloggen is gelukt',
							color: 'success'
						});

					}).catch((err) => {
						this.$vs.loading.close('.loginCard > .con-vs-loading')
						this.$vs.notify({
							title: 'Oops!',
							text: 'Het inloggen is mislukt, controleer je gegevens',
							color: 'danger'
						});
					});

				} else {
					this.$vs.loading.close('.loginCard > .con-vs-loading');
				}
			});
		},
	}
}
</script>

<style lang="scss">
#page-login {
	.social-login-buttons {
		.bg-facebook {
			background-color: #1551b1
		}

		.bg-twitter {
			background-color: #00aaff
		}

		.bg-google {
			background-color: #4285F4
		}

		.bg-github {
			background-color: #333
		}
	}

	#alertLoginFaild {
		margin-bottom: 25px;
	}
}
</style>
